<template>
  <v-col style="max-width: 900px">
    <h1 class="primary--text">
      {{ $t('documentation.texts.groups.unregisteredCifs.title') }}
    </h1>
    <p>{{ $t('documentation.texts.groups.unregisteredCifs.p1') }}</p>
    <v-img
      style="
        width: 100%;
        max-width: 860px;
        margin-top: 10px;
        margin-bottom: 20px;
      "
      contain
      :src="pic1Name"
    />
    <p>{{ $t('documentation.texts.groups.unregisteredCifs.p2') }}</p>
    <v-img
      style="
        width: 100%;
        max-width: 460px;
        margin-top: 10px;
        margin-bottom: 20px;
      "
      contain
      :src="pic2Name"
    />
    <p>{{ $t('documentation.texts.groups.unregisteredCifs.p3') }}</p>
    <v-img
      style="
        width: 100%;
        max-width: 860px;
        margin-top: 10px;
        margin-bottom: 20px;
      "
      contain
      :src="pic3Name"
    />
    <p>{{ $t('documentation.texts.groups.unregisteredCifs.p4') }}</p>
    <v-img
      style="
        width: 100%;
        max-width: 460px;
        margin-top: 10px;
        margin-bottom: 20px;
      "
      contain
      :src="pic4Name"
    />
  </v-col>
</template>

<script>
export default {
  computed: {
    pic1Name() {
      return require('@/assets/documentation/groups/' +
        this.$t('documentation.texts.groups.unregisteredCifs.pic1') +
        '.png')
    },
    pic2Name() {
      return require('@/assets/documentation/groups/' +
        this.$t('documentation.texts.groups.unregisteredCifs.pic2') +
        '.png')
    },
    pic3Name() {
      return require('@/assets/documentation/groups/' +
        this.$t('documentation.texts.groups.unregisteredCifs.pic3') +
        '.png')
    },
    pic4Name() {
      return require('@/assets/documentation/groups/' +
        this.$t('documentation.texts.groups.unregisteredCifs.pic4') +
        '.png')
    },
  },
}
</script>

<style>
.custom-link {
  transition: 0.3s;
  cursor: pointer;
}
.custom-link:hover {
  text-decoration: underline;
}
</style>
